const FETCH_INCIDENT_BY_ID = "incidents::fetch";
const FETCH_INCIDENT_BY_ID_SUCCESS = "incidents::fetch::success";
const LOAD_INCIDENTS = "incidents::load";
const LOAD_INCIDENTS_SUCCESS = "incidents::load::success";
const RESOLVE_INCIDENT = "incidents::resolve";
const RESOLVE_INCIDENT_SUCCESS = "incidents::resolve::success";
const UNLOAD_INCIDENTS = "incidents::unload";

const unloadIncidentsAction = {
  type: UNLOAD_INCIDENTS,
};

export {
  FETCH_INCIDENT_BY_ID,
  FETCH_INCIDENT_BY_ID_SUCCESS,
  LOAD_INCIDENTS,
  LOAD_INCIDENTS_SUCCESS,
  RESOLVE_INCIDENT,
  RESOLVE_INCIDENT_SUCCESS,
  UNLOAD_INCIDENTS,
  unloadIncidentsAction,
};
